import React from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SET_ACTIVE_BOARD } from '../../../../redux/types';

import './boardsTabs.scss';

const BoardsTabs = ({ boards }) => {
  const dispatch = useDispatch();
  return (
    <div className='boards-tabs-container'>
      <div className='boards-tabs'>
        {boards.map((x) => (
          <NavLink className={({ isActive }) => (isActive ? 'boardBtn boardBtnActive' : 'boardBtn')} key={x.id}
                   to={`./${x.id}`}>
            <span onClick={() => dispatch({ type: SET_ACTIVE_BOARD, activeBoard: x.id })}>{x.name}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default BoardsTabs;